import React, { useState, useEffect } from 'react';
import authHeader from '../services/AuthHeader';
import axios from 'axios';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import './style.css';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';

const MockUser = (props) => {
  const [selected, setSelected] = useState([]);
  const [options, setOptions] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [showButton, setShowButton] = useState(false);

  localStorage.removeItem('studentVoted');

  let history = useHistory();

  const nextPath = (path) => {
    history.push(path);
  };

  /* Get election data */
  const tempOptions = JSON.parse(localStorage.getItem('options')) || {};
  let tempVotes = props.votes;
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_BASE + 'election/', {
        headers: authHeader(),
      })
      .then((res) => {
        tempVotes.ElectionId = res.data.electionId;
        props.setBallotData(res.data);
        setLoading(false);
      });
  }, []);

  /* if tempOptions from local storage is empty get data from API and store in local storage */
  useEffect(() => {
    if (
      tempOptions &&
      Object.keys(tempOptions).length === 0 &&
      Object.getPrototypeOf(tempOptions) === Object.prototype
    ) {
      axios
        .get(process.env.REACT_APP_API_BASE + 'mockstudent', {
          headers: authHeader(),
        })
        .then((res) => {
          setOptions(res.data);
          localStorage.setItem('options', JSON.stringify(res.data));
          setLoading(false);
        });
    } else {
      setOptions(tempOptions);
      setLoading(false);
    }
  }, []);

  /* get selected student info */
  useEffect(() => {
    if (selected.length) {
      axios
        .get(
          process.env.REACT_APP_API_BASE + 'studentinfo/' + selected[0].starId,
          { headers: authHeader() }
        )
        .then((res) => {
          props.setStudentInfo(res.data);
          setShowButton(true);
        });
    }
  }, [selected]);

  /* set state of votes */
  useEffect(() => {
    if (selected.length) {
      tempVotes.UUID = uuidv4();
      tempVotes.allBallots = [];
      tempVotes.StarId = selected[0].starId;
      props.setVotes(tempVotes);
    }
  }, [selected]);

  if (isLoading) {
    return <div className='App'>Loading...</div>;
  }
  /* select student from populated list */
  const handleChangeTypeahead = function (selectedOptions) {
    setSelected(selectedOptions);
    if (selectedOptions.length) {
      props.setMock(selectedOptions[0]);
    } else {
      setShowButton(false);
    }
  };
  /* set data for mocked student */
  const ShowMockStudent = () => {
    if (selected.length) {
      return (
        <>
          <div className='box-voter text-center'>
            <h2 className='h3'>Student to Mock</h2>
            <div>First Name: {selected[0].first_Name}</div>
            <div>Last Name: {selected[0].last_Name}</div>
            <div>Middle Name: {selected[0].middle_Name}</div>
            <div>Star ID: {selected[0].starId}</div>
            <div>Tech ID: {selected[0].tech_ID}</div>
          </div>
          <br />
        </>
      );
    } else {
      return <div>Pick a student to mock</div>;
    }
  };

  return (
    <>
      <h1 className='h2'>Mock User</h1>
      <label htmlFor='basic-example'>Choose a student to mock</label>
      <Typeahead
        id='basic-example'
        onChange={handleChangeTypeahead}
        labelKey='starId'
        options={options}
        placeholder='Choose a user to mock'
        selected={selected}
      />
      <br />
      <ShowMockStudent />
      <Button
        className='btn btn-default'
        type='submit'
        onClick={() => nextPath('/ballot')}
        disabled={!showButton}
        style={{ marginBottom: '20px' }}
      >
        Mock User
      </Button>
    </>
  );
};

export default MockUser;
